import axios from 'axios'
import { User, CreateUserRequest } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const getUsers = async (): Promise<User[]> => {
  const response = await api.get('/users')
  return response.data.data
}

export const createUser = async (
  userData: CreateUserRequest,
): Promise<User> => {
  const response = await api.post('/users', userData)
  return response.data.data
}

export const updateUser = async (
  id: string,
  userData: Partial<CreateUserRequest>,
): Promise<User> => {
  const response = await api.put(`/users/${id}`, userData)
  return response.data.data
}

export const deleteUser = async (id: string): Promise<void> => {
  await api.delete(`/users/${id}`)
}
